<template>

  <div class="pb50">
    <el-form ref="form" size="small" :model="form" label-width="200px">
      <div class="common-form">设置</div>
       <el-form-item label="是否开启发布素材通道">
        <el-radio-group v-model="form.is_suggestion_open">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
        <div class="lh18 mt10 gray9">
          <p>开启后，用户端可以发布</p>
        </div>
      </el-form-item>
     
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" size="small" @click="onSubmit" :loading="loading">提交</el-button>
      </div>

    </el-form>
  </div>
</template>
<script>
  import SuggestionApi from '@/api/suggestion.js';
  export default {
    data() {
      return {
        form: {
          is_suggestion_open: 0,
          suggestion_points:0,
          max_suggestion_points:0,
          suggestion_profits: 0,
          suggestion_order_points: 0,
          sensitive_words:'',
        },
        loading: false,
      };
    },
    created() {
      /*获取数据*/
      this.getData();
    },
    methods: {
      /*获取数据*/
      getData() {
        let self = this;
        let Params = {};
        SuggestionApi.getSetting(Params, true).then(res => {
          self.form = res.data.setting;
          if(res.data.setting.is_suggestion_open){
             self.form.is_suggestion_open = parseInt(res.data.setting.is_suggestion_open);
          }
         
        }).catch(error => {

        });
      },

      /*保存*/
      onSubmit() {
        let self = this;
        let form = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            suggestionApi.setSetting(form, true)
              .then(data => {
                self.loading = false;
                if (data.code == 1) {
                  self.$message({
                    message: '恭喜你，保存成功',
                    type: 'success'
                  });
                } else {
                  self.loading = false;
                }
              })
              .catch(error => {
                self.loading = false;
              });

          }
        });


      },
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/suggestion/setting/Setting.vue